import ritualLogo from "@/assets/ritual-logo.png";
import { cn } from "@/lib/utils";
import { LucideProps } from "lucide-react";
import { forwardRef } from "react";

interface RitualIconProps {
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
  xl: "h-8 w-8",
};

export function RitualIcon({ className, size = "md" }: RitualIconProps) {
  return (
    <img
      src={ritualLogo}
      alt="Ritual"
      className={cn(sizeClasses[size], "object-contain", className)}
    />
  );
}

// Lucide-compatible icon component for use in nav items
export const RitualIconLucide = forwardRef<SVGSVGElement, LucideProps>(
  ({ className, ...props }, ref) => {
    // We use an img wrapped in a span to mimic SVG behavior
    return (
      <span className={cn("inline-flex items-center justify-center", className)}>
        <img
          src={ritualLogo}
          alt="Ritual"
          className="h-full w-full object-contain"
        />
      </span>
    );
  }
);
RitualIconLucide.displayName = "RitualIconLucide";
